module.exports = function getResource(label, vars = []) {
    let resources = {
        startAReturn: 'Commencer un retour'
    };

    return resources[label];
};
